module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Caption1"
  }, [_vm._v("Autumn Buttons Bracelet")]), _vm._v(" "), _c('div', {
    staticClass: "orang"
  }, [_c('p', {
    staticClass: "ackhd1"
  }, [_vm._v("MY BIGGEST FANS")]), _vm._v(" "), _c('p', {
    staticClass: "ackc"
  }, [_vm._v("To my husband, Kevin, and daughter, Gwen—thank you for your unconditional love and support and for allowing me to play in my room.")]), _vm._v(" "), _c('p', {
    staticClass: "ackc"
  }, [_vm._v("With love, me")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d4fd37e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/04_Fm_big.vue
// module id = 66
// module chunks = 0